module.exports = "/_next/static/images/ad73d01b8cff61d1840569a41ec780ca-pj-man-holding-business-card@2x.jpg";